import React from "react";
import { AuthProvider } from "../../../AuthContext.js";
import RutasAdministrador from "../rutas/RutasAdministrador.js";
import Header from "../../../componentes/layouts/Headers.js";
import Footer from "../../../componentes/layouts/Footer.js";

const AppAdministrador = () => {
    return (
        <AuthProvider>
            <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
                <Header />
                <div style={{ paddingTop: "6rem", flex: 1 }} className="container">
                    <RutasAdministrador />
                </div>
                <Footer />
            </div>
        </AuthProvider>
    );
};

export default AppAdministrador;
